module.exports = __webpack_public_path__ + "static/img/tj1.88f74d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tj1.png
// module id = 2AuN
// module chunks = 0